export function UnimayMediaImage() {
    return (
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_49_149)">
                <circle cx="60" cy="60" r="50" fill="#FF4B4A" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M43.3333 29.5822C43.3333 25.2647 46.8334 21.7646 51.1509 21.7646H68.8492C73.1667 21.7646 76.6667 25.2647 76.6667 29.5822V38.0674C76.6667 38.2301 76.5245 38.3552 76.3618 38.3552H67.622C66.2188 38.3552 65.0813 39.4738 65.0813 40.8537C65.0813 42.2337 66.2188 43.3523 67.622 43.3523H76.3618C76.5245 43.3523 76.6667 43.4774 76.6667 43.6401V48.2616C76.6667 48.4242 76.5245 48.5493 76.3618 48.5493H67.622C66.2188 48.5493 65.0813 49.668 65.0813 51.0479C65.0813 52.4278 66.2188 53.5465 67.622 53.5465H76.3618C76.5245 53.5465 76.6667 53.6716 76.6667 53.8343V59.0554C76.6667 59.2181 76.5245 59.3432 76.3618 59.3432H67.622C66.2188 59.3432 65.0813 60.4618 65.0813 61.8417C65.0813 63.2217 66.2188 64.3403 67.622 64.3403H76.3618C76.5245 64.3403 76.6667 64.4654 76.6667 64.6281V74.4887C76.6667 79.4817 72.619 83.5294 67.626 83.5294H52.374C47.381 83.5294 43.3333 79.4817 43.3333 74.4887V64.6281C43.3333 64.4654 43.4756 64.3403 43.6382 64.3403H52.3781C53.7812 64.3403 54.9187 63.2217 54.9187 61.8417C54.9187 60.4618 53.7812 59.3432 52.3781 59.3432H43.6382C43.4756 59.3432 43.3333 59.2181 43.3333 59.0554V53.8343C43.3333 53.6716 43.4756 53.5465 43.6382 53.5465H52.3781C53.7812 53.5465 54.9187 52.4278 54.9187 51.0479C54.9187 49.668 53.7812 48.5493 52.3781 48.5493H43.6382C43.4756 48.5493 43.3333 48.4242 43.3333 48.2616V43.6401C43.3333 43.4774 43.4756 43.3523 43.6382 43.3523H52.3781C53.7812 43.3523 54.9187 42.2337 54.9187 40.8537C54.9187 39.4738 53.7812 38.3552 52.3781 38.3552H43.6382C43.4756 38.3552 43.3333 38.2301 43.3333 38.0674V29.5822Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M39.7489 47.2549H34.5098V69.8039C34.5098 83.8818 45.9221 95.2941 60 95.2941C74.0778 95.2941 85.4902 83.8817 85.4902 69.8039V47.2549H80.2511V70.3775C80.2511 81.3863 71.1287 90.3108 60 90.3108C48.8713 90.3108 39.7489 81.3863 39.7489 70.3775V47.2549Z"
                    fill="white"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_49_149"
                    x="0"
                    y="0"
                    width="120"
                    height="120"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_49_149" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_49_149"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}
